import { Capacitor } from '@capacitor/core';

import { Logger } from '@mopla/logger';

import { environment } from '../../../environments/environment';

//for more information on GoogleTagManager check https://mopla-solutions.atlassian.net/wiki/spaces/M/pages/817102850/

const gtmConfig = environment.googleTagManager;

/**
 * Initialize Google Tag Manager (GTM) for analytics tracking.
 *
 * GTM containers:
 * - Production: GTM-WFMZXZX9 (production analytics)
 * - All other environments: GTM-W85G5NR8 (shared non-production analytics)
 *
 * Web only. Native apps route to the Firebase Analytics SDK instead — see
 * initUserTracking for why the two paths are separate.
 */
export const initGoogleTagManager = () => {
	const logger = Logger.getInstance('GTM');
	const gtmContainerId = gtmConfig.googleTagManagerContainerId;

	logger.debug('GTM: initializing', {
		gtmContainerId,
		platform: Capacitor.getPlatform(),
		env: environment.env,
		origin: window.location.origin,
	});

	if (!gtmContainerId) {
		logger.error('GTM Container ID missing! Skipping initialization.');
		return;
	}

	insertGoogleTagManagerSnippet(logger, gtmContainerId);
};

function insertGoogleTagManagerSnippet(
	logger: ReturnType<typeof Logger.getInstance>,
	gtmContainerId: string
) {
	(function (w, d, i) {
		w.dataLayer = w.dataLayer || [];
		w.dataLayer.push({
			'gtm.start': new Date().getTime(),
			event: 'gtm.js',
		});
		const f = d.getElementsByTagName('script')[0],
			j = d.createElement('script');

		j.async = true;
		j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i;

		const insertedAt = performance.now();

		j.onload = () => {
			logger.debug('GTM: container script loaded', {
				gtmContainerId: i,
			});
		};

		j.onerror = () => {
			logger.error(`Failed to load GTM script for container ${i}`, undefined, {
				online: navigator.onLine,
				elapsedMs: Math.round(performance.now() - insertedAt),
			});
		};

		f.parentNode?.insertBefore(j, f);
	})(window, document, gtmContainerId);
}
